import {Injectable, OnDestroy} from '@angular/core';
import {IClientContext} from "../../../app.services/user.context/interfaces/Iclient.context";
import {Observable, BehaviorSubject} from "rxjs";
import {ClientContextProxy} from "./client.context.proxy";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Injectable()
export class ClientContextService implements OnDestroy {
	public subject: BehaviorSubject<IClientContext>;

	constructor(private clientContextProxy:ClientContextProxy) {
		this.subject = new BehaviorSubject<IClientContext>(null);
	}

	ngOnDestroy() { }

	public getDNSName():Observable<string> {
		return this.clientContextProxy.getClientDNSName();
	}

	public load() : Observable<IClientContext> {
		this.getClientContext().pipe(untilDestroyed(this)).subscribe((clientContext: IClientContext) => {
			this.subject.next(clientContext);
		});

		return this.subject.asObservable();
	}

	public getCachedClientContextAsObservable(): Observable<IClientContext> {
		return this.subject.asObservable();
	}

	public getCachedClientContext():IClientContext {
		return this.subject.getValue();
	}

	public getClientContext():Observable<IClientContext> {
		return this.clientContextProxy.getClientContext();
	}
}
